export function handleCalculatePrice(
    coloreDiStampaInput: HTMLInputElement,
    fronteRetroInput: HTMLInputElement,
    pagesInSheet: number,
    rilegaturaSelect: HTMLSelectElement,
    surplus: number = 0
) {
  // How many pages in one sheet

  const [coloreDiStampa, fronteRetro, rilegatura] = [
    coloreDiStampaInput.value,
    fronteRetroInput.value,
    rilegaturaSelect.value,
  ];

  // Price of the inputs
  const inputsPrice = Number(coloreDiStampa) + Number(fronteRetro);

  // Multiply by number of pages (which are divide in cae of different layouts)
  const priceByPages = inputsPrice * pagesInSheet;

  // Adds rilegatura price to the total
  const finalPrice = priceByPages + Number(rilegatura) + surplus;

  return finalPrice.toFixed(2);
}
